import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';
import SearchBar from '../SearchBar';

export interface ICallout {
	image: IImage;
	link?: ILink;
}

export interface IMainSearchSectionProps extends IBaseElementProps {
	children?: any;
	heading?: string;
	/**
	 * @control textarea
	 */
	leadInText?: string;
	searchSectionCallouts: ICallout[];
}

/**
 * Main Search Section
 * @block
 * @requiresHooks
 * @icon search
 */
const MainSearchSection: React.FC<IMainSearchSectionProps> = ({
	children,
	className,
	classNames = [],
	heading,
	leadInText,
	searchSectionCallouts,
}) => (
	<div className={className || cn('main-search-section', ...classNames)}>
		<div className="main-search-section__container container-fluid p-0">
			<SearchBar backgroundColour="white" />
			<div className="main-search-section__text-content">
				{heading && (
					<h2 className="main-search-section__heading">{heading}</h2>
				)}
				{leadInText && (
					<p className="main-search-section__lead-in-text lead">
						{leadInText}
					</p>
				)}
			</div>
			{searchSectionCallouts.length > 0 && (
				<div className="main-search-section__callouts container-fluid">
					<div className="row">
						{searchSectionCallouts.map((callout, index) => (
							<div
								className="main-search-section__callout col-12 col-md-4 p-0"
								key={index}
							>
								{callout.link && (
									<a
										className="main-search-section__callout-link"
										href={callout.link.href}
									>
										{callout.image && (
											<div className="main-search-section__callout-image-container">
												<Image
													className="main-search-section__callout-image img-fluid"
													{...callout.image}
												/>
											</div>
										)}
										<div className="main-search-section__callout-text">
											<span>{callout.link.label}</span>
										</div>
									</a>
								)}
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	</div>
);

export default MainSearchSection;
